package fr.manyverse.app.presentation.viewmodel

import fr.manyverse.app.domain.model.Universe
import fr.manyverse.app.domain.usecase.GetUniversesUseCase
import fr.manyverse.app.presentation.state.AsyncUiState
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

class UniverseSelectionViewModel(
    private val getUniversesUseCase: GetUniversesUseCase
) : BaseViewModel() {

    private val _uiState = MutableStateFlow<AsyncUiState<List<Universe>>>(AsyncUiState.Idle)
    val uiState: StateFlow<AsyncUiState<List<Universe>>> = _uiState.asStateFlow()

    fun loadUniverses(userId: String) {
        launchAsync(_uiState) {
            getUniversesUseCase(userId)
        }
    }
}
